import aframe from "aframe";

aframe.registerComponent("bomber-times", {
  schema: {
    times: {
      default: [],
      // Comma separated vec3s
      parse: function(value) {
        return typeof value === "object"
          ? value
          : value.split(",").map(v => {
            const [time, number, bombs, splitSize, speed] = v
              .trim(" ")
              .split(" ")
              .map(s => Number.parseFloat(s));
            return {
              time,
              number,
              bombs,
              splitSize,
              speed
            };
          });
      }
    },
    bombSpeed: { default: 0.03 },
    speed: { default: 0.05 }
  },
  play() {
    if (!this.started) {
      this.el.components["wave-queue"].registerGenerator(this.iter());
      this.prevTime = 0;
      this.timer = 0;
      this.started = true;
    }
  },
  tick(t, dt) {
    this.timer += dt;
  },
  * iter() {
    let prevTime = this.timer;
    while (true) {
      if (
        !this.data.times.length ||
        this.data.times[this.data.times.length - 1].time < prevTime
      ) {
        break;
      }

      const waves = [];

      for (let i = 0; i < this.data.times.length; i++) {
        const spawnTime = this.data.times[i].time;
        if (prevTime <= spawnTime && this.timer > spawnTime) {
          const number = this.data.times[i].number;
          for (let n = 0; n < number; n++) {
            waves.push(this.bomber(this.data.times[i]));
          }
        }
      }

      prevTime = this.timer;
      yield waves;
    }

    yield "done";
  },
  bomber({ bombs, splitSize, speed }) {
    return {
      type: "bomber",
      data: {
        bombSpeed: this.data.bombSpeed,
        bombs,
        splitSize,
        speed: speed || this.data.speed
      }
    };
  }
});
